import "moment-timezone";
import React from "react";

const RegularAvailability = ({ regularAvailability, setEditMode, ...rest }) => (
  <div {...rest}>
    <h4>
      Regular Hours <small className='btn btn-link' onClick={() => setEditMode(true)}>edit</small>
    </h4>
    <table className="table table-condensed table-zebra">
      <thead>
        <tr>
          <th style={{ width: 150 }}>Day</th>
          <th style={{ width: 250 }}>Work Hours</th>
          <th></th>
        </tr>
      </thead>
      <tbody>
        {[
          "Monday",
          "Tuesday",
          "Wednesday",
          "Thursday",
          "Friday",
          "Saturday",
          "Sunday",
        ].map((day) => {
          const times = regularAvailability[day.toLowerCase()] || [];
          const slots = times
            .map((time) => `${time.from}-${time.to}`)
            .join(", ");
          return (
            <tr key={day}>
              <td>{day}</td>
              <td>
                {slots}
                {times.length === 0 && (
                  <span style={{ color: "#888" }}>not working</span>
                )}
              </td>
            </tr>
          );
        })}
      </tbody>
    </table>
  </div>
);

export default RegularAvailability